import * as React from 'react';
import { TOrderStatusEnum } from 'api/orders/orders.types';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import {
  getLabelCellClassName,
  getOrderStatusSequence,
  getRingColumnClassName,
  orderStatusToLabelKey,
} from './OrderStatusProgress.utils';
import './OrderStatusProgress.styled.scss';

export type TOrderStatusProgressProps = {
  status: TOrderStatusEnum;
};

export const OrderStatusProgress: React.FC<TOrderStatusProgressProps> = ({
  status,
}) => {
  const localize = useLocalize();
  const orderStatusSequence = getOrderStatusSequence(status);
  const currentStepIndex = orderStatusSequence.indexOf(status);
  const safeIndex = currentStepIndex >= 0 ? currentStepIndex : 0;
  const progress = ((safeIndex + 1) / orderStatusSequence.length) * 100;
  const isRefunded = status === TOrderStatusEnum.Refunded;

  return (
    <div
      className={`admin-order-status-progress ${
        isRefunded ? 'admin-order-status-progress--refunded' : ''
      }`}
    >
      <div className="admin-order-status-progress__rings-row">
        <div className="admin-order-status-progress__bar-bg" aria-hidden />
        <div
          className="admin-order-status-progress__bar-fill"
          style={{ width: `${progress}%` }}
          aria-hidden
        />
        {orderStatusSequence.map((stepStatus, index) => {
          const isActive = stepStatus === status;
          const isCompleted = index < safeIndex;
          const isRefundedActive = isActive && isRefunded;
          return (
            <div
              key={stepStatus}
              className={getRingColumnClassName(
                isActive,
                isCompleted,
                isRefundedActive
              )}
            >
              <div className="admin-order-status-progress__step-number">
                {isCompleted ? '✓' : index + 1}
              </div>
            </div>
          );
        })}
      </div>
      <div className="admin-order-status-progress__labels-row">
        {orderStatusSequence.map((stepStatus, index) => {
          const isActive = stepStatus === status;
          const isCompleted = index < safeIndex;
          const isRefundedActive = isActive && isRefunded;
          return (
            <div
              key={stepStatus}
              className={getLabelCellClassName(
                isActive,
                isCompleted,
                isRefundedActive
              )}
            >
              <span className="admin-order-status-progress__step-label">
                {localize(orderStatusToLabelKey[stepStatus])}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
